import { os } from '@zhiyi/utils'

export default (() => {
  return os().isTablet
})()

export const getIsIPad = () => {
  return os().isTablet
}

export const isIphone = (() => {
  return os().isPhone
})()
